import "./styles.scss";

import { useTranslation } from "react-i18next";

import Button from "components/Button";

const mainClass = "faq-need-help";

const NeedHelp = () => {
  const { t } = useTranslation();

  return (
    <div className={mainClass}>
      <div className={`${mainClass}__text`}>
        <span className="light">{t("Need help?")}</span>
        <p className="light">
          {t(
            "Use our contact form or schedule an online meeting. Our specialists will get in touch with you as soon as possible."
          )}
        </p>
      </div>
      <div className={`${mainClass}__buttons`}>
        <Button href="/contact" fullWidth>
          {t("contact us")}
        </Button>
      </div>
    </div>
  );
};

export default NeedHelp;
